export const adminMenu = [
  {
    firstName: "대쉬보드",
    firstLink: "/admin",
    second: [],
  },
  {
    firstName: "관리",
    firstLink: "/admin/member/management",
    second: [
      {
        secondName: "회원관리",
        secondLink: "/admin/member/management",
      },
      {
        secondName: "상품 관리",
        secondLink: "/admin/product/management",
      },
      {
        secondName: "게시판 관리",
        secondLink: "/admin/board/management",
      },
    ],
  },
  {
    firstName: "결제 관리",
    firstLink: "/admin/pay/management",
    second: [],
  },
  {
    firstName: "채팅 관리",
    firstLink: "/admin/chat/management",
    second: [],
  },
];
